import styles from "./LinkButton.module.scss";
import { Title2, SubTitle2, SubTitle3 } from "@components/new/Typo";
import Icon from "@components/new/Icon";
import cn from "classnames";
import { Link } from 'react-router-dom';
import { LinkButtonSize, LinkButtonProps } from "./types.ts";

export const LinkButton = ({
  size,
  disabled,
  className,
  icon,
  iconClassName,
  rightIcon,
  rightIconClassName,
  title,
  onClick,
  to,
  external,
}: LinkButtonProps) => {
  const btnSize = size || LinkButtonSize.L;

  const Text = {
    [LinkButtonSize.L]: Title2,
    [LinkButtonSize.M]: SubTitle2,
    [LinkButtonSize.S]: SubTitle3,
  }[btnSize];

  const content = (
    <>
      {icon && (
        <Icon className={cn(styles.icon, iconClassName)} icon={icon} />
      )}
      <Text className={styles.title}>{title}</Text>
      {rightIcon && (
        <Icon className={cn(styles.icon, rightIconClassName)} icon={rightIcon} />
      )}
    </>
  )

  if (to && !disabled) {
    return external ? (
      <a
        href={to}
        target="_blank"
        className={cn(
          styles.button,
          className,
          styles[`size-${btnSize}`],
          disabled && styles.disabled,
        )}
        onClick={(e: any) => e.stopPropagation()}
      >
        {content}
      </a>
    ) : (
      <Link
        to={to}
        className={cn(
          styles.button,
          className,
          styles[`size-${btnSize}`],
          disabled && styles.disabled,
        )}
        onClick={(e: any) => e.stopPropagation()}
      >
        {content}
      </Link>
    )
  }

  const handleOnClick = (e: any) => {
    e.stopPropagation();
    if (!disabled && onClick) onClick(e);
  }

  return (
    <button
      onClick={handleOnClick}
      className={cn(
        styles.button,
        className,
        styles[`size-${btnSize}`],
      )}
      disabled={disabled}
      type="button"
    >
      {content}
    </button>
  );
};
